// extracted by mini-css-extract-plugin
export default {"body":"Footer_body__eJ3fQ","copyright":"Footer_copyright__M+WO2"};